module.exports = __webpack_public_path__ + "static/media/WorcesterBackground.56a48698.jpg";